import React, { useState} from "react";
import Modal from 'react-modal';
import styles from './TestResultModal.module.css';
import Loader from '../Loader';

function TestResultModal({isOpen,onRequestClose,test,handleSampleResult}){

    const [result, setResult]=useState(test.testResult||"");
    const[values,setValues]=useState(test.testValues||"");
  
    const[antibodies,setAntibodies]=useState(test.testAntibodies||"");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        setLoading(true);
        console.log("handle submit",result,values,antibodies);
        try {
            const success = await handleSampleResult(test.id,{result,values,antibodies});
            if (success) {
                onRequestClose();
            }
        } finally {
            setLoading(false);
        }
    };

  // useEffect(()=>{
  //   if(test){
  //     setResult(test.testResult || "");
  //     setValues(test.testValues || "");
  //     setAntibodies(test.testAntibodies || "");
  //   }
  // },[test])
  console.log("test from hospital email modal",test)

    return (
        <Modal
          isOpen={isOpen}
          onRequestClose={onRequestClose}
          contentLabel="Test Result Modal"
          className={styles.modalContent}
        >
          <h2 className={styles.modalHeader}>Enter Test Result</h2>
          <button className={styles.closeButton} onClick={onRequestClose}>×</button>
          <hr></hr>
          <form onSubmit={(e) => e.preventDefault()}>
            <div className={styles.formGroup}>
              <label>Result:</label>
              <select value={result} onChange={(e) => setResult(e.target.value)}>
                <option value="">Select</option>
               
                <option value="Positive">Positive</option>
                <option value="Negative">Negative</option>
              </select>
            </div>
            
            <div className={styles.formGroup}>
              <label>Values:</label>
              <input
                type="text"
                value={values}
                onChange={(e) => setValues(e.target.value)}
              />
            </div>
            <div className={styles.formGroup}>
              <label>Antibodies:</label>
              <input
                type="text"
                value={antibodies}
                onChange={(e) => setAntibodies(e.target.value)}
              />
            </div>
            <div className={styles.buttonGroup}>
              <button type="button" onClick={handleSubmit} disabled={loading}>
                {loading ? 'Saving...' : 'Save'}
              </button>
              <button type="button" onClick={onRequestClose} disabled={loading}>
                Cancel
              </button>
            </div>
            {loading && <Loader />}
          </form>
        </Modal>
      );
    }
    




    export default TestResultModal;